













































































































































































































// vue
import { ref, defineComponent, watch } from '@vue/composition-api';

// services
import { useService } from '@/vue3/api/services';

// hooks
import { useGeoRecord } from '@/vue3/hooks/geoRecordHook';
import { useCoursePdf } from '@/vue3/hooks/coursePdfHook';
import { useStore } from '@/store';

// primevue
import TabView from 'primevue/tabview';
import Dropdown from 'primevue/dropdown';
import TabPanel from 'primevue/tabpanel';
import Button from 'primevue/button';
import ProgressSpinner from 'primevue/progressspinner';

export default defineComponent({
    components: {
        TabView,
        TabPanel,
        Button,
        ProgressSpinner,
        Dropdown,
    },
    props: {
        mapbox: {
            type: Object,
            default: null,
        },
        isNavigationOpen: {
            type: Boolean,
            default: false,
        },
        drawerOpenStateExternalFlag: {
            type: Boolean,
            default: false,
        },
        setIsNavigationOpen: {
            type: Function,
            default: () => {},
        },
        geoRecords: {
            type: Array,
            default: () => [],
        },
        measureRecords: {
            type: Array,
            default: () => [],
        },
        zoomedMapBbox: {
            type: Array,
            default: () => [],
        },
        courseExtent: {
            type: Object,
            default: null,
        },
    },
    setup(props: any, vm) {
        // services
        const { globalUndo } = useService();

        // hooks
        const store = useStore();

        const {
            generateScreenshot,
            isGeneratingPdf,
            pdfOption,
            pdfHoleOption,
            pdfPageSize,
            pdfPageResolution,
            pdfSelection,
        } = useCoursePdf();

        const { removeGeoRecord, addGeoRecord, refreshGeoRecord } =
            useGeoRecord();

        // refs
        const isUtilityOpen = ref(props.drawerOpenStateExternalFlag);

        const utilityTabIndex = ref(0);

        const filteredGeoRecords = ref<any[]>([]);

        const filteredMeasureRecords = ref<any[]>([]);

        const isPDFOptionOpen = ref(false);

        const isHoleOptionOpen = ref(false);
        const isGreenOptionOpen = ref<Boolean>(false);

        const selection = ref('All holes');

        const pageResolution = ref('Normal');

        const pageSize = ref('A4 Portrait');

        const holeNo = ref(1);

        //watcher
        watch(
            () => props.drawerOpenStateExternalFlag,
            (value) => {
                isUtilityOpen.value = value;
            },
        );

        watch(
            () => props.mapbox.currentHole,
            (value) => {
                holeNo.value = value;
                pdfOption.holeNo = value;
            },
        );

        // methods
        const undo = async () => {
            let res = await globalUndo(store.getters.currentCourseSchema.id);

            if (res.isCreated) {
                removeGeoRecord(props.mapbox.map, res.geoRecord);
            } else if (res.isDeleted) {
                addGeoRecord(props.mapbox.map, res.geoRecord);
            } else {
                refreshGeoRecord(props.mapbox.map, res.geoRecord, true);
            }
        };

        const setUtilityTabIndex = (i: number) => {
            utilityTabIndex.value = i;
        };

        const getGeoRecordFiltered = (): void => {
            if (!props.mapbox.map.getSource('geo-records')) return;

            let geoRecordIds = props.mapbox.map
                .querySourceFeatures('geo-records', {
                    sourceLayer: 'geo-records',
                })
                .filter((feature: any) => feature.properties.isVisible === true)
                .map((feature: any) => feature.properties.id);

            filteredGeoRecords.value = props.geoRecords.filter(
                (geoRecord: any) => geoRecordIds.includes(geoRecord.id),
            );
        };

        const getMeasureRecordFiltered = (): void => {
            if (!props.mapbox.map.getSource('measure-records')) return;

            if (
                props.mapbox.map.getSource('measure-records')._data.features
                    .length === 0
            ) {
                filteredMeasureRecords.value = [];
                return;
            }

            let measureRecordIds = props.mapbox.map
                .querySourceFeatures('measure-records', {
                    sourceLayer: 'measure-records',
                })
                .filter((feature: any) => feature.properties.isVisible === true)
                .map((feature: any) => feature.properties.measureRecordId);

            filteredMeasureRecords.value = props.measureRecords.filter(
                (measureRecord: any) =>
                    measureRecordIds.includes(measureRecord.id),
            );
        };

        const filterVisibleLayers = () => {
            return props.mapbox.map
                .getStyle()
                .layers.filter((layer: any) => {
                    return (
                        layer.source === 'clere' ||
                        layer.source === 'clere-mosaic' ||
                        layer.source === 'clere-raster' ||
                        layer.source === 'geo-records' ||
                        layer.source === 'measure-records'
                    );
                })
                .filter((layer: any) => {
                    return (
                        props.mapbox.map.getLayoutProperty(
                            layer.id,
                            'visibility',
                        ) !== 'none'
                    );
                });
        };

        const getPdfGenerated = async (): Promise<void> => {
            getGeoRecordFiltered();
            getMeasureRecordFiltered();
            isPDFOptionOpen.value = false;
            try {
                await generateScreenshot(
                    props.courseExtent,
                    9,
                    filteredGeoRecords.value,
                    filteredMeasureRecords.value,
                    filterVisibleLayers(),
                    props.zoomedMapBbox,
                );
            } catch (error) {
                console.log(error);
            }
        };

        const setPDFOption = (): void => {
            pdfOption.selection = selection.value;
            pdfOption.pageSize = pageSize.value;
            pdfOption.resolution = pageResolution.value;
            pdfOption.holeNo = holeNo.value;

            selection.value == 'Select hole'
                ? (isHoleOptionOpen.value = true)
                : (isHoleOptionOpen.value = false);

            selection.value === 'Zoomed in green'
                ? (isGreenOptionOpen.value = true)
                : (isGreenOptionOpen.value = false);
        };

        const togglePDFOption = () => {
            isPDFOptionOpen.value = !isPDFOptionOpen.value;
        };

        return {
            store,
            isUtilityOpen,
            vm,
            undo,
            utilityTabIndex,
            setUtilityTabIndex,
            generateScreenshot,
            getPdfGenerated,
            isGeneratingPdf,
            isPDFOptionOpen,
            isHoleOptionOpen,
            setPDFOption,
            pdfSelection,
            pdfHoleOption,
            selection,
            pdfPageResolution,
            pageResolution,
            pdfPageSize,
            pageSize,
            holeNo,
            togglePDFOption,
            isGreenOptionOpen,
        };
    },
});
